import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-686f77ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "row h-100"
}
const _hoisted_3 = { class: "col-md-3 h-100 d-flex flex-column" }
const _hoisted_4 = { class: "mb-4 text-center" }
const _hoisted_5 = {
  class: "btn btn-light position-relative",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addStepModal"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-4" }, " Add your first milestone", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "scroll-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_milestone_progress_line = _resolveComponent("milestone-progress-line")!
  const _component_modules_element = _resolveComponent("modules-element")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_step_modal = _resolveComponent("add-step-modal")!
  const _component_add_module_modal = _resolveComponent("add-module-modal")!
  const _component_rename_step_modal = _resolveComponent("rename-step-modal")!
  const _component_delete_step_modal = _resolveComponent("delete-step-modal")!
  const _component_ModuleDoneWithTasksModal = _resolveComponent("ModuleDoneWithTasksModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.modulesByMiletsones.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_feather_icon, {
                  type: "plus-square",
                  size: "16",
                  class: "position-absolute mt-1"
                }),
                _hoisted_6
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_draggable, {
      modelValue: _ctx.modulesByMiletsones,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modulesByMiletsones) = $event)),
      group: "steps",
      "item-key": "stepId",
      class: "row h-100",
      disabled: !_ctx.isReadOnly
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", {
          class: "col-md-3 h-100 d-flex flex-column process-column",
          onClick: ($event: any) => (_ctx.selectedModule = element)
        }, [
          _createVNode(_component_milestone_progress_line, {
            stepName: element.name,
            stepId: element.stepId,
            stats: element.stats
          }, null, 8, ["stepName", "stepId", "stats"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_modules_element, {
              modules: element.modules,
              "onUpdate:modules": ($event: any) => ((element.modules) = $event),
              stepId: element.stepId,
              onSelectedModule: _cache[0] || (_cache[0] = ($event: any) => {_ctx.selectedModule = $event;})
            }, null, 8, ["modules", "onUpdate:modules", "stepId"])
          ])
        ], 8, _hoisted_7)
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createVNode(_component_add_step_modal, {
      stepId: _ctx.selectedModule.stepId,
      weight: _ctx.selectedModule.weight
    }, null, 8, ["stepId", "weight"]),
    _createVNode(_component_add_module_modal, {
      stepId: _ctx.selectedModule.stepId
    }, null, 8, ["stepId"]),
    _createVNode(_component_rename_step_modal, {
      stepId: _ctx.selectedModule.stepId
    }, null, 8, ["stepId"]),
    _createVNode(_component_delete_step_modal, {
      stepId: _ctx.selectedModule.stepId
    }, null, 8, ["stepId"]),
    _createVNode(_component_ModuleDoneWithTasksModal, { onSubmitted: _ctx.toggleModuleDone }, null, 8, ["onSubmitted"])
  ]))
}